import { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  cursor: 'pointer',
};
